module.exports = __webpack_public_path__ + "img/lange_crub_3.2196f61e.jpg";